(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8c83"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8c83"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1MMdM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14cfaddf7b657fa6$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "whenGlobal", function () { return $14cfaddf7b657fa6$export$42a7c3ec3c3dde5a; });
$parcel$export(module.exports, "documentSignal", function () { return $14cfaddf7b657fa6$export$5b0c92123667125b; });
// Runs a block initializer on the frontend (once the DOM is ready) or after
// every ACF preview render in the editor. The initializer receives the root
// to search in and `{ isEditor }`.
function $14cfaddf7b657fa6$export$2e2bcd8739ae039(slug, init) {
    var acf = window.acf, wp = window.wp;
    if ((acf === null || acf === void 0 ? void 0 : acf.addAction) && (wp === null || wp === void 0 ? void 0 : wp.blocks)) {
        acf.addAction("render_block_preview/type=".concat(slug), function($block) {
            var root = ($block === null || $block === void 0 ? void 0 : $block.jquery) ? $block.get(0) : $block;
            if (root) init(root, {
                isEditor: true
            });
        });
        return;
    }
    var run = function() {
        return init(document, {
            isEditor: false
        });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
}
function $14cfaddf7b657fa6$export$42a7c3ec3c3dde5a(win, name, callback) {
    if (win[name]) {
        callback(win[name]);
        return;
    }
    win.addEventListener('load', function() {
        if (win[name]) callback(win[name]);
    }, {
        once: true
    });
}
function $14cfaddf7b657fa6$export$5b0c92123667125b(doc, key, instance) {
    var _instance_closest, _store_get;
    var store = doc.juniperBlockSignals || new Map();
    // eslint-disable-next-line no-param-reassign
    doc.juniperBlockSignals = store;
    var id = instance ? "".concat(key, ":").concat(((_instance_closest = instance.closest('[data-block]')) === null || _instance_closest === void 0 ? void 0 : _instance_closest.dataset.block) || '') : key;
    (_store_get = store.get(id)) === null || _store_get === void 0 ? void 0 : _store_get.abort();
    var controller = new AbortController();
    store.set(id, controller);
    return controller.signal;
}

});


var $1MMdM = parcelRequire("1MMdM");
function $c07b767abc52dbb3$var$initHeroSlider(root, param) {
    var isEditor = param.isEditor;
    var block = root.querySelector('.hero-slider');
    var sliderEl = block === null || block === void 0 ? void 0 : block.querySelector('.hero-slider__swiper');
    if (!sliderEl || sliderEl.dataset.runtimeReady === 'true') return;
    sliderEl.dataset.runtimeReady = 'true';
    var pauseBtn = block.querySelector('.hero-slider__pause');
    var pauseIcon = pauseBtn === null || pauseBtn === void 0 ? void 0 : pauseBtn.querySelector('.hero-slider__pause-icon--pause');
    var playIcon = pauseBtn === null || pauseBtn === void 0 ? void 0 : pauseBtn.querySelector('.hero-slider__pause-icon--play');
    (0, $1MMdM.whenGlobal)(sliderEl.ownerDocument.defaultView, 'Swiper', function(Swiper) {
        var swiper = new Swiper(sliderEl, {
            loop: true,
            autoplay: isEditor ? false : {
                delay: 5000,
                disableOnInteraction: false
            },
            speed: 600,
            navigation: {
                prevEl: block.querySelector('.hero-slider__arrow--prev'),
                nextEl: block.querySelector('.hero-slider__arrow--next')
            },
            pagination: {
                el: block.querySelector('.hero-slider__pagination'),
                clickable: true
            }
        });
        // Autoplay stays off in the editor, so the toggle has nothing to control.
        if (isEditor) return;
        // ── Pause / play toggle ───────────────────────────────────────────────────
        pauseBtn === null || pauseBtn === void 0 ? void 0 : pauseBtn.addEventListener('click', function() {
            var isPaused = pauseBtn.getAttribute('aria-pressed') === 'true';
            if (isPaused) {
                swiper.autoplay.start();
                pauseBtn.setAttribute('aria-pressed', 'false');
                pauseBtn.setAttribute('aria-label', pauseBtn.dataset.labelPause);
                if (pauseIcon) pauseIcon.style.display = '';
                if (playIcon) playIcon.style.display = 'none';
            } else {
                swiper.autoplay.stop();
                pauseBtn.setAttribute('aria-pressed', 'true');
                pauseBtn.setAttribute('aria-label', pauseBtn.dataset.labelPlay);
                if (pauseIcon) pauseIcon.style.display = 'none';
                if (playIcon) playIcon.style.display = '';
            }
        });
    });
}
(0, $1MMdM.default)('hero-slider', $c07b767abc52dbb3$var$initHeroSlider);

})();
//# sourceMappingURL=script.js.map
